import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

export const Container = styled.div<any>`
  border-radius: 50px;
  box-shadow: 0px 0px 5px 0 #d4d4d4;

  position: ${(props) => props.mobile ? 'fixed' : 'absolute'};;
  right: 51px;
  overflow: hidden;
  z-index: 999;
  bottom: ${(props) => props.mobile && '2em'};
  background: rgba(166,166,166,0.5);

  @media (max-width: ${customTheme.breakpoints[1]}) {
    right: 15px;
  }
  
  transition: background-color 0.3s;

  &:hover {
    background: rgba(166,166,166,0.5);
    & > section {
      opacity: 1;
      display: block;
    }
  }

  & > section {
    opacity: 0;
    display: none;

    transition: opacity 0.3s;
  }

`

export const Item = styled.div<any>`
  ${(props) => props.mobile && 'background: rgba(166,166,166,0.5);'}
  width: 55px;
  height: 55px;
  
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  cursor: pointer;
  padding: 5px;
  font-size: 36px;

  img {
    height: auto;
    width: 100%;
  }
`

export const Image = styled.img`
`
